import {checkStatus} from '../utils/api';
import {registerCollaborateMiddleware} from './collaborate';
import {API} from '../routes.js';

export function createApiMiddleware({start, success, error, apiHandler}) {
    return (store, {payload}) => {
        store.dispatch({
            type: start,
            payload
        });
        apiHandler(payload)
            .then(checkStatus)
            .then((response) => response.json())
            .then((apiData) => {
                store.dispatch({
                    type: success,
                    payload: {
                        ...payload,
                        apiData
                    }
                });
            })
            .catch((apiData) => {
                store.dispatch({
                    type: error,
                    payload: {
                        ...payload,
                        apiData
                    }
                });
            });
    };
}

export const apiRoot = `${API}/tripboard`;

export const defaultFetchOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

if (typeof window !== 'undefined' && window.ha) {
    defaultFetchOptions.headers['x-csrf-token'] = window.ha.crumb;
}

function registerAllMiddleware() {
    registerCollaborateMiddleware();
}

export default registerAllMiddleware;



// WEBPACK FOOTER //
// ./src/universal/tripboard/middleware.js